import { HumanTaskIsRequiredBlockFormField } from './lib/IsRequiredField';
import { type HumanTaskBlockFormFieldsProps } from './types';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskFileUploadBlockFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <>
      <BlockValueTemplateField label="Field label" fieldName={`${fieldNamePrefix}.label`} />
      <BlockValueTemplateField
        label="Variable name"
        fieldName={`${fieldNamePrefix}.variableName`}
      />
      <HumanTaskIsRequiredBlockFormField fieldNamePrefix={fieldNamePrefix} />
    </>
  );
}
